import { VCard } from 'vuetify/lib/components/VCard';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("menu.dp.bigquery_consumption"))),
      ]),
      _c(VCard, { staticClass: "mt-2", staticStyle: { height: "1100px" } }, [
        _c("iframe", {
          staticStyle: { border: "0" },
          attrs: {
            frameborder: "0",
            allowfullscreen: "",
            width: "100%",
            height: "100%",
            src: "https://datastudio.google.com/embed/reporting/8aa73cad-8d70-4e47-9152-735ffc8c3772/page/cgrJB",
          },
        }),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }